import { EuiFlexGroup, EuiFormLabel, EuiSelect } from '@elastic/eui';
import { useIntl } from 'react-intl';
import { country, provinces, regions, websites } from 'cache';

import * as S from './FiltersSidebar.styles';
import { useReactiveVar } from '@apollo/client';
import { Country } from 'my-lib';

export const CountryFilter = (): JSX.Element | null => {
  const { formatMessage } = useIntl();
  const currentCountry = useReactiveVar(country);

  const options = [
    { value: 'ITALY', text: formatMessage({ id: 'ITALY' }) },
    { value: 'GERMANY', text: formatMessage({ id: 'GERMANY' }) },
  ];

  return (
    <S.SidebarFilterWrapper>
      <EuiFlexGroup direction="column">
        <EuiFormLabel style={{ marginRight: '10px' }}>{formatMessage({ id: 'filters.country.label' })}</EuiFormLabel>
        <EuiSelect
          options={options}
          onChange={(x): void => {
            provinces([]);
            websites([]);
            regions([]);
            country(x.target.value as Country);
          }}
          value={currentCountry as unknown as string}
        />
      </EuiFlexGroup>
    </S.SidebarFilterWrapper>
  );
};
